<template>
    <section class="search-form">
        <!-- {{'test:' + test}} -->
        <el-form ref="searchForm" :inline="true" :model="data" class="demo-form-inline" @submit.native.prevent>
            <el-row>
                <el-col :span="5" v-for="(item, index) in searchItems" :key="'first'+index">
                    <el-form-item :label="item.label" :prop="item.prop" v-if="index < 4 && !item.hidden">
                        <template v-if="item.type == 'text'">
                            <el-input v-model="data[item.prop]" :placeholder="item.label" size="small" @keyup.enter.native="onSubmit"></el-input>
                        </template>
                        <template v-if="item.type == 'select'">
                            <pf-select :api="item.api" :prop="item.prop" :filterable="item.filterable" :options="item.options" v-model="data[item.prop]"></pf-select>
                        </template>
                        <template v-if="item.type == 'date' || item.type == 'year' || item.type == 'month'">
                            <el-date-picker
                                    v-model="data[item.prop]"
                                    :type="item.type" size="small" :format="item.format" :value-format="item.format" style="width: 100%;">
                            </el-date-picker>
                        </template>
                        <template v-if="item.type == 'week'">
                            <el-date-picker v-model="data[item.prop]" :type="item.type" size="small" :format="item.format" style="width: 100%;"></el-date-picker>
                        </template>
                        <template v-if="item.type == 'dateRange'">
                            <el-date-picker v-model="data[item.prop]"
                                            type="daterange" size="small"
                                            unlink-panels
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                            :value-format="item.format" style="width: 100%;">
                            </el-date-picker>
                        </template>
                        <template v-if="item.type == 'radio'">
                            <el-radio v-model="data[item.prop]" v-for="(option, oIndex) in item.options" :label="option.value" :key="'firsto'+oIndex" size="mini">{{option.label}}</el-radio>
                        </template>
                        <template v-if="item.type == 'deptSelect'">
                            <pf-department v-model="data[item.prop]"/>
                        </template>
                        <template v-if="item.type == 'district'">
                            <pf-district v-model="data[item.prop]" :prop="item.prop"></pf-district>
                        </template>
                        <template v-if="item.type == 'dic'">
                            <pf-dic :type="item.typeName" :prop="item.prop" v-model="data[item.prop]"></pf-dic>
                        </template>
                        <template v-if="item.type == 'department'">
                            <pf-department v-model="data[item.prop]"/>
                        </template>
                        <template v-if="item.type == 'inputRange'">
                            <el-col :span="11">
                                <el-input v-model="data[item.props[0]]" placeholder="最小金额" size="mini"></el-input>
                            </el-col>
                            <el-col class="line" :span="2" style="text-align: center;">-</el-col>
                            <el-col :span="11">
                                <el-input v-model="data[item.props[1]]" placeholder="最大金额" size="mini"></el-input>
                            </el-col>
                        </template>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item class="tool-buttons">
                        <el-button type="primary" @click="onSubmit" size="small" icon="el-icon-search">查询</el-button>
                        <el-button @click="resetForm()" size="small" icon="el-icon-refresh-right">重置</el-button>
                        <!-- <el-button @click="more()" size="small" icon="el-icon-more" v-if="showMoreBtn && !showMore && searchItems.filter(_x=>_x.hidden !== true).length > 2">更多</el-button>
                        <el-button @click="hideMore()" size="small" icon="el-icon-arrow-up" v-if="showMoreBtn && showMore">收起</el-button> -->
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-show="!showMore">
                <el-col :span="6" v-for="(item, index) in searchItems" :key="'next'+index">
                    <el-form-item :label="item.label" :prop="item.prop" v-if="index >= 4  && !item.hidden">
                        <template v-if="item.type == 'text'">
                            <el-input v-model="data[item.prop]" :placeholder="item.label" size="small" @keyup.enter.native="onSubmit"></el-input>
                        </template>
                        <template v-if="item.type == 'select'">
                            <pf-select :api="item.api" :prop="item.prop" :options="item.options" v-model="data[item.prop]" :automatic-dropdown="true"></pf-select>
                        </template>
                        <template v-if="item.type == 'date' || item.type == 'year' || item.type == 'month'">
                            <el-date-picker
                                    v-model="data[item.prop]"
                                    :type="item.type" size="small" :format="item.format" :value-format="item.format" style="width: 100%;">
                            </el-date-picker>
                        </template>
                        <template v-if="item.type == 'week'">
                            <el-date-picker
                                    v-model="data[item.prop]"
                                    :type="item.type" size="small" :format="item.format" style="width: 100%;">
                            </el-date-picker>
                        </template>
                        <template v-if="item.type == 'dateRange'">
                            <el-date-picker
                                    v-model="data[item.prop]"
                                    type="daterange" size="small"
                                    unlink-panels
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    :value-format="item.format" style="width: 100%;">
                            </el-date-picker>
                        </template>
                        <template v-if="item.type == 'radio'">
                            <el-radio v-model="data[item.prop]" v-for="(option, oIndex) in item.options" :label="option.value" :key="'nexto'+oIndex" size="mini">{{option.label}}</el-radio>
                        </template>
                        <template v-if="item.type == 'deptSelect'">
                            <pf-department v-model="data[item.prop]"/>
                        </template>
                        <template v-if="item.type == 'district'">
                            <pf-district v-model="data[item.prop]"></pf-district>
                        </template>
                        <template v-if="item.type == 'cityLevel'">
                            <el-col :span="16">
                                <pf-district v-model="data[item.props[0]]"></pf-district>
                            </el-col>
                            <el-col :span="8">
                                <el-checkbox style="margin-left: 5px;" v-model="data[item.props[1]]">{{ item.checkboxLabel }}</el-checkbox>
                            </el-col>
                        </template>
                        <template v-if="item.type == 'dic'">
                            <pf-dic :type="item.typeName" :prop="item.prop" v-model="data[item.prop]"></pf-dic>
                        </template>
                        <template v-if="item.type == 'inputRange'">
                            <el-col :span="11">
                                <el-input v-model="data[item.props[0]]" placeholder="最小金额" size="mini"></el-input>
                            </el-col>
                            <el-col class="line" :span="2" style="text-align: center;">-</el-col>
                            <el-col :span="11">
                                <el-input v-model="data[item.props[1]]" placeholder="最大金额" size="mini"></el-input>
                            </el-col>
                        </template>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </section>
</template>
<script>
export default {
  name: 'searchForm',
  props: {
    searchItems: {type: Array, default: () => []},
    showMoreBtn: {type: Boolean, default: true} // 是否显示更多
  },
  data() {
    return {
      data: {},
      searchParams: [],
      showMore: false // 显示更多
    }
  },
  mounted() {
    document.onkeydown = event => {
      event = event || (window.event ? window.event : null)
      if (event.keyCode === 13) {
        this.onSubmit()
      }
    }
  },
  methods: {
    more() {
      this.showMore = true
    },
    hideMore() {
      this.showMore = false
    },
    resetForm() {
      this.searchItems.forEach(item => {
        if (item.prop) {
          this.$set(this.data, item.prop, '')
        }
        if (item.props) {
          item.props.map(subItem => {
            this.$set(this.data, subItem, '')
          })
        }
      })
    },

    onSubmit() {
      this.searchParams = []
      for (const key in this.data) {
        let value = this.data[key]
        const obj = this.searchItems.find(item => item.prop == key)
        if (value) {
          if (obj.type == 'dateRange') {
            value = this.data[key].join(',')
          };
          this.searchParams.push({
            column: key,
            type: obj.searchKey,
            val: value
          })
        }
      }
      this.$emit('refresh', {searchParams: this.searchParams})
    },
    // 清空数据
    clearData () {
      this.data = {}
      this.searchParams = []
    }
  }

}
</script>
<style lang="scss" scoped>
    .search-form {
        padding: 16px 0;
        .el-form {
            ::v-deep{
                .el-form-item {
                    display: flex;
                    width: 100%;
                    margin-bottom: 0px;
                    .el-form-item__label {
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        line-height: normal;
                        width: 33%;
                        font-size: 14px;
                    }
                    .el-form-item__content {
                        width: 62%;
                    }
                    .el-select {
                        width:100%;
                    }
                    .el-radio__label {
                        font-size: 12px;
                    }
                    &.tool-buttons {
                        display: flex;
                        justify-content: flex-end;
                        .el-form-item__content {
                            width: 100%;
                            .el-button {
                                font-size: 14px;
                                font-weight: normal;
                                &.el-button--primary {
                                    background-color: #2789EE;
                                    &:hover, &:focus {
                                        background-color: #1D78D6;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
